import React from "react";
import "../CareersStyles/ApplicationProcess.css";

const ApplicationProcess = () => {
  return (
    <div className="container">
      <div className="left-content">
        <h1>Ready to Join Bellary Info Tech Solutions?</h1>
        <p>
          Bellary Info Tech Soltions is excited to welcome new talent to our team! Join us
          and be part of an innovative and growth-driven environment. Start your
          career with us today and unlock endless opportunities.
        </p>
      </div>
      <div className="right-box">
        <h2>Application Process</h2>
        <div className="box-content">
          <h3>Recruitment</h3>
          <h3>Apptitude Round</h3>
          <h3>Technical Round</h3>
          <h3>HR Interview</h3>
        </div>
      </div>
    </div>
  );
};

export default ApplicationProcess;
